import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { RemoteUserScreenComponent } from './remote-user-screen/remote-user-screen.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { VideoCallingComponent } from './video-calling/video-calling.component';
import { CustomerVerificationComponent } from './customer-verification/customer-verification.component';

const routes: Routes = [
  { path: "", pathMatch:'full', redirectTo: "accept-invitation" },
  { path: "customer-verification", component: CustomerVerificationComponent },
  // { path: "accept-invitation/:id/:token/:clientid", component: TermsAndConditionsComponent },
  // { path: "accept-invitation/:id/:token/:clientid/:caseid", component: TermsAndConditionsComponent },
  { path: "accept-invitation", component: TermsAndConditionsComponent },
  // { path: "accept-invitation", component: TermsAndConditionsComponent },
  { path: "video-calling", component: VideoCallingComponent },
  // { path: "invite", component: RemoteUserScreenComponent },
  { path: "invite/:id", component: RemoteUserScreenComponent },
  { path: "**", redirectTo: "accept-invitation" }
];

@NgModule({
  // imports: [RouterModule.forRoot(routes, { useHash: true }), CommonModule, FormsModule],
  imports: [RouterModule.forRoot(routes,{useHash:false}),  CommonModule, FormsModule],
  exports: [RouterModule]
})
export class AppRoutingModule { }
